module.exports = __webpack_public_path__ + "img/RectánguloT1.365230f1.svg";